<div class="container-fluid test">
  <div class="row d-flex flex-sm-row  flex-column-reverse signupmobile" >
    <div class="col-md-6 bgS1 p-5 position-relative d-sm-block d-none aos-init aos-animate" data-aos="fade-up">
      <div class="row">
        <div class="col text-center" style="margin-top: 45%;">
          <img src="assets/sumo-webbtree.svg" class="img-fluid" alt="Search toolbox" title="Search toolbox">
        </div>
      </div>
    </div>
    <div class="col-md-6 p-5 testmobile aos-init aos-animate signup-div" data-aos="fade-up">
      <div class="row mr-2" *ngIf="invalidCode || codeAlreadyUsed">
        <div class="col">
          <p class="text-danger" *ngIf="invalidCode">
            This code is invalid. Please enter a valid code.
          </p>
          <p class="text-danger" *ngIf="codeAlreadyUsed">
            This code is already used by some other account please reach us to
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row d-block d-sm-none">
            <div class="col">
              <img src="assets/webtree.png" class="img-fluid" alt="Webbtree" title="Webbtree">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col pr-0" style="color: #484b59;">
              <p class="f-20 mb-3 txt-prim" style="font-weight: 600;">
                Sign Up for Webbtree Talent Discovery
              </p>
              <p class="txt-prim text-9696 mb-0" style="font-size: 14px; margin-top: -8px;">
                AppSumo Exclusive! Unlock AI-powered sourcing and seamless hiring.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col pr-sm-0">
              <form [formGroup]="signupform">

                <!-- <div class="row">
                  <div class="col-md-8 tcm d-flex flex-column flex-sm-row">
                    <div class="mr-5 position-relative" [class.mt-4]="isMobile">
                      <div class="googleSignIn  mb-4" #googleSignUpButton>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="row mr-2">
                  <div class="col">
                    <div class="f-14 font-weight-400 mb-3"> First Name <span class="text-danger">*</span>
                      <input data-testid="auto-app-newsignup-input-1" type="text" placeholder="Enter First Name" class="wc-form-control nobg mt-1"
                        formControlName="firstName">
                      <p *ngIf="signupform.get('firstName').errors?.required && (signupform['controls'].firstName.dirty || signupform['controls'].firstName.touched)"
                        [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger">First Name is required</p>
                      <p *ngIf="signupform['controls'].firstName.hasError('pattern')" class="text-danger f-12 pt-1">
                        HTML tags are not allowed</p>
                    </div>
                  </div>
                  <div class="col">
                    <div class="f-14 font-weight-400 mb-3"> Last Name <span class="text-danger">*</span>
                      <input data-testid="auto-app-newsignup-input-2" type="text" placeholder="Enter Last Name" class="wc-form-control nobg mt-1"
                        formControlName="lastName">
                      <p *ngIf="signupform.get('lastName').errors?.required && (signupform['controls'].lastName.dirty || signupform['controls'].lastName.touched)"
                        [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger">Last Name is required</p>
                      <p *ngIf="signupform['controls'].lastName.hasError('pattern')" class="text-danger f-12 pt-1">
                        HTML tags are not allowed</p>
                    </div>
                  </div>
                </div>

                <div class="row mr-2 mt-2">
                  <div class="col-md-8">
                    <div class="f-14 font-weight-400 mb-3"> Work Email ID <span class="text-danger">*</span>
                      <input data-testid="auto-app-newsignup-input-3" type="text" placeholder="Enter Work Email ID" class="wc-form-control nobg mt-1"
                        formControlName="loginemail">
                      <p *ngIf="signupform.get('loginemail').errors?.required && (signupform['controls'].loginemail.dirty || signupform['controls'].loginemail.touched)"
                        [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger">Work Email ID is required</p>
                      <p class="text-danger f-12 pt-1" *ngIf="signupform['controls'].loginemail.hasError('pattern')">
                        Must be a valid loginemail</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <!-- // button to send the otp -->
                    <button data-testid="auto-app-newsignup-button-1" type="button" class="btn f-14 font-weight-500 bgRequestBtn mt-4" (click)="sendOtp()"
                      style="width: 100%;"
                      [ngClass]="{'disable-generate': (isOtpSent == true ||  isOtpSent == false), 'generate-otp': (signupform.get('loginemail').valid && isOtpSent == false)}">
                      <span>Generate OTP
                      </span>
                    </button>
                  </div>

                  <div class="f-14 font-weight-400 mb-3 col-md-4 mt-2"> OTP <span class="text-danger">*</span>
                    <input data-testid="auto-app-newsignup-input-4" type="number" placeholder="Enter OTP" class="wc-form-control nobg mt-1" 
                      formControlName="otp">
                      <!-- <input data-testid="auto-app-newsignup-input-5" type="text" maxlength="6" formControlName="otp" class="otp-box" type="text" minlength="6"/> -->


                    <p *ngIf="signupform.get('otp').errors?.required && (signupform['controls'].otp.dirty || signupform['controls'].otp.touched)"
                      [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger">OTP is required</p>
                    <p *ngIf="signupform['controls'].otp.hasError('pattern')" class="text-danger f-12 pt-1">
                      HTML tags are not allowed</p>
                  </div>
                  
                  <!-- // add an option to send otp -->
                  <div class="col-md-6" style="margin-top: 47px;" >
                    <div class="timer-section" *ngIf="isOtpSent == true && isOtpVerified == false" style="margin-left: -15px;">
                      <span *ngIf="countdown > 0"> Resend OTP in 
                      </span>
                      
                      <span *ngIf="countdown > 0" class="countdown ml-2">
                        <i class="fa-regular fa-clock text-red" style="margin-right: 2px;"></i> <span class="text-red">00:{{ countdown | number:'2.0'
                          }} </span>
                      </span>
                      
                      
                      
                    <span (click)="retryOtp()" class="retry" *ngIf="countdown == 0"
                          [ngClass]="{'retry': countdown == 0, 'pointer-none': countdown > 0}">
                          Resend OTP</span>
                    </div>
                    
                    
                    <!-- <div class="f-12 font-weight-500 mb-3"> OTP
                      <span class="text-danger">*</span>
                      <input data-testid="auto-app-newsignup-input-6" type="text" placeholder="Enter OTP" class="wc-form-control nobg mt-1"
                        formControlName="otp">
                      <p *ngIf="signupform.get('otp').errors?.required && (signupform['controls'].otp.dirty || signupform['controls'].otp.touched)"
                        [ngClass]="['text-right','my-1','text-danger']">OTP is required</p>
                      <p class="text-danger f-12 pt-1" *ngIf="signupform['controls'].otp.hasError('pattern')">
                        Must be a valid OTP</p>
                    </div> -->



                   
                    
                    
                    <!-- <div class="otp-container">
                      <label for="otp">OTP</label>
                      <div class="d-flex ">
                        <div class="otp-inputs"> -->
                          <!-- <div *ngFor="let control of [0, 1, 2, 3, 4, 5]; let i = index">
                            <input data-testid="auto-app-newsignup-input-7" type="text" maxlength="1" formControlName="otp{{i}}" class="otp-box" type="text"
                              maxlength="1" [(ngModel)]="otpArray[i]" class="otp-box" />
                          </div> -->
                          <!-- <input data-testid="auto-app-newsignup-input-8" type="text" maxlength="6" formControlName="otp" class="otp-box" type="text" minlength="6"/>
                          
                        </div>

                        
                      </div>



                    </div> -->



                  </div>
                  <!-- <div class="col-md-4" *ngIf="isOtpSent == true">
                    <button data-testid="auto-app-newsignup-button-2" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn mt-4"
                      (click)="verifyOtp()" *ngIf="isOtpVerified == false">Verify OTP</button>
                      <p *ngIf="isOtpVerified">Otp Verified</p>
                  </div> -->
                </div>

                <!-- <div class="row mr-2 mt-4">
                  <div class="col">
                    <div class="f-12 font-weight-500 mb-3"> Phone Number <span class="text-danger">*</span>
                      <input data-testid="auto-app-newsignup-input-9" type="text" placeholder="Enter Phone Number" class="wc-form-control nobg mt-1"
                        formControlName="mobileno">
                      <p *ngIf="signupform.get('mobileno').errors?.required && (signupform['controls'].mobileno.dirty || signupform['controls'].mobileno.touched)"
                        [ngClass]="['text-right','my-1','text-danger']">Phone Number is required</p>
                      <p class="text-danger f-12 pt-1" *ngIf="signupform['controls'].mobileno.hasError('pattern')">
                        Must be a valid Mobile No</p>
                    </div>
                  </div>
                </div> -->

                <div class="row mr-4 mt-2">


                  <div class="f-14 font-weight-400 mb-3 col-md-6"> Company
                    <input data-testid="auto-app-newsignup-input-10" type="text" placeholder="e.g. google, Tesla" class="wc-form-control nobg mt-1"
                      formControlName="companyname">

                    <p *ngIf="signupform.get('companyname').errors?.required && (signupform['controls'].companyname.dirty || signupform['controls'].companyname.touched)"
                      [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger f-12">Company Name is required</p>
                    <p *ngIf="signupform['controls'].companyname.hasError('pattern')" class="text-danger f-12 pt-1">
                      HTML tags are not allowed</p>
                  </div>

                  <div class="f-14 font-weight-400 mb-3 col-md-6"> Designation
                    <input data-testid="auto-app-newsignup-input-11" type="text" placeholder="e.g. Software Engineer" class="wc-form-control nobg mt-1" formControlName="designation">

                    <p *ngIf="signupform.get('designation').errors?.required && (signupform['controls'].designation.dirty || signupform['controls'].designation.touched)"
                      [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger f-12">Designation is required</p>
                    <p *ngIf="signupform['controls'].designation.hasError('pattern')" class="text-danger f-12 pt-1">
                      HTML tags are not allowed</p>
                  </div>

                  <!-- <div class="f-12 font-weight-500 mb-3 col-md-6"> Set Password <span class="text-danger">*</span> <i class="fas fa-info-circle hoverToShowGuideline">
                    <div class="searchGuide">
                      <div class="row">
                          <div class="col">
                            <ul>
                              <li>
                                8-48 characters
                              </li>
                              <li>
                                Start with a letter (A-Z a-z)
                              </li>
                              <li>
                                Include 1 special character
                              </li>
                              <li>
                                Include 1 number (0-9)
                              </li>
                              
                            </ul>
                      

                          </div>   
                     
                      </div>
                    </div>
                    </i>  
                      <input data-testid="auto-app-newsignup-input-12" type="password" placeholder="Enter Password" class="wc-form-control nobg mt-1"
                        formControlName="password">

                      <p *ngIf="signupform.get('password').errors?.required && (signupform['controls'].password.dirty || signupform['controls'].password.touched)"
                        [ngClass]="['text-right','my-1','text-danger']">Password is required</p>
                  </div> -->


                  <!-- <div class="f-12 font-weight-500 mb-3 col-md-6"> Re-type Password <span class="text-danger">*</span>
                    <input data-testid="auto-app-newsignup-input-13" type="password" placeholder="Re-type Password" (input)="reconfirmpwd()"
                      class="wc-form-control nobg mt-1" formControlName="confirmpwd">

                    <p *ngIf="signupform.get('confirmpwd').errors?.required && (signupform['controls'].confirmpwd.dirty || signupform['controls'].confirmpwd.touched)"
                      [ngClass]="['text-right','my-1','text-danger']">Confirm password is required</p>

                    <p class="text-danger f-12 pt-1"
                      *ngIf="signupform['controls'].confirmpwd.hasError('invalidpwd')">
                      Password Doesn't Match </p>

                  </div> -->

                </div>
                <div class="row mr-4 mt-2">
                  <div class="col-md-6 mb-4 position-relative">
                    <p>Password</p>
                    <!-- <label for="websiteurl">Set password<span class="text-danger">*</span></label> -->
                    <input data-testid="auto-app-newsignup-input-14" [type]="show ? 'text' : 'password'" type="password" formControlName="password"
                      class="wc-form-control" placeholder="Password" (click)="showpassworderror()"
                      (focusout)="focusOut()">
                    <span style="position: relative;"><i class="fas text-webbtree-green showpassword"
                        [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'" (click)="show=!show"></i></span>
                    <p class="text-danger f-12 mb-0 text-right"
                      *ngIf="signupform.controls['password'].hasError('required') && signupform.controls['password'].touched">
                      Password is compulsory</p>
                    <p class="text-danger f-12 mb-0 text-right"
                      *ngIf="!signupform.controls['password'].hasError('required') && signupform.controls['password'].touched">
                      <ng-container *ngIf="(signupform.controls['password'].hasError('required')
                  || signupform.controls['password'].hasError('minlength')
                  || signupform.controls['password'].hasError('hasNumber')
                  || signupform.controls['password'].hasError('hasCapitalCase')
                  || signupform.controls['password'].hasError('hasSmallCase')
                  || signupform.controls['password'].hasError('hasSpecialCharacters')
                  || signupform.controls['password'].hasError('hasKeyword')); else PasswordError">
                        Invalid password pattern
                      </ng-container>
                      <ng-template #PasswordError></ng-template>
                    </p>

                    <div class="passwordValidMsg" *ngIf="showpassword">
                      <label class="col f-12 d-flex"
                        [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasKeyword')  ? 'text-danger' : 'text-success'">
                        <i class="material-icons f-12 mr-1">{{
                          signupform.controls['password'].hasError('required') ||
                          signupform.controls['password'].hasError('hasKeyword') ? 'cancel' :
                          'check_circle' }}</i>
                        Cannot contain reserved keywords for e.g. 'password'
                      </label>
                      <label class="col f-12 d-flex"
                        [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                        <i class="material-icons f-12 mr-1">{{
                          signupform.controls['password'].hasError('required') ||
                          signupform.controls['password'].hasError('minlength') ? 'cancel' :
                          'check_circle' }}</i>
                        Must be at least 8 characters!
                      </label>
                      <label class="col f-12 d-flex"
                        [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                        <i class="material-icons f-12 mr-1">{{
                          signupform.controls['password'].hasError('required') ||
                          signupform.controls['password'].hasError('hasNumber') ? 'cancel' :
                          'check_circle' }}</i>
                        Must contain at least 1 number!
                      </label>
                      <label class="col f-12 d-flex"
                        [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                        <i class="material-icons f-12 mr-1">{{
                          signupform.controls['password'].hasError('required') ||
                          signupform.controls['password'].hasError('hasCapitalCase') ? 'cancel'
                          : 'check_circle' }}</i>
                        Must contain at least 1 in Capital Case!
                      </label>
                      <label class="col f-12 d-flex"
                        [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                        <i class="material-icons f-12 mr-1">{{
                          signupform.controls['password'].hasError('required') ||
                          signupform.controls['password'].hasError('hasSmallCase') ? 'cancel' :
                          'check_circle' }}</i>
                        Must contain at least 1 Letter in Small Case!
                      </label>
                      <label class="col f-12 d-flex"
                        [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                        <i class="material-icons f-12 mr-1">{{
                          signupform.controls['password'].hasError('required') ||
                          signupform.controls['password'].hasError('hasSpecialCharacters') ?
                          'cancel' :
                          'check_circle' }}</i>
                        Must contain at least 1 Special Character!
                      </label>
                    </div>

                  </div>
                  <div class="col-md-6 mb-4">
                    <p>Confirm Password</p>
                    <!-- <label for="websiteurl">Re-type password <span class="text-danger">*</span></label> -->
                    <input data-testid="auto-app-newsignup-input-15" [type]="showConfirm ? 'text' : 'password'" class="wc-form-control" name="password"
                      formControlName="confirmpassword" id="password" placeholder="Re-Enter Password">
                    <span style="position: relative;"><i class="fas text-webbtree-green showpassword"
                        [ngClass]="showConfirm ? 'fa-eye-slash' : 'fa-eye'"
                        (click)="showConfirm=!showConfirm"></i></span>

                    <p class="text-danger f-12 text-right mb-0"
                      *ngIf="signupform.controls['confirmpassword'].hasError('required') && signupform.controls['confirmpassword'].touched">
                      Password is compulsory</p>
                    <p class="f-12 text-danger text-right mb-0"
                      *ngIf="!signupform.controls['confirmpassword'].hasError('required') && signupform.controls['confirmpassword'].hasError('invalidpwd') && signupform.controls['confirmpassword'].touched">
                      Password do not match.</p>
                  </div>
                </div>

                <div class="d-flex align-items-center mb-4 mt-1">
                  <label class="wc-checkbox mr-3 mb-0">
                    <input data-testid="auto-app-newsignup-input-16" type="checkbox" id="mycheck" name="mycheck" formControlName="termsaccept">
                    <i class="fas fa-check"></i>
                  </label>
                  <label class="mb-0" for="mycheck">
                    <span class="f-2"> I agree to <a data-testid="auto-app-newsignup-a-1" href="https://www.webbtree.com/terms-and-conditions"
                        target="_blank" tabindex="-1">
                        Terms of Services
                      </a> and <a data-testid="auto-app-newsignup-a-2" href="https://www.webbtree.com/privacy-policy" target="_blank" tabindex="-1">
                        Privacy Policy
                      </a></span>
                  </label>
                  <div *ngIf="signupform.get('termsaccept').hasError('requiredTrue') && signupform.get('termsaccept').touched">
                    You must accept the terms and conditions.
                  </div>
                </div>
                <p class="text-danger f-12 pt-1" *ngIf="termsacceptError">
                  Please Accept Terms </p>
               <button data-testid="auto-app-newsignup-button-3" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn mr-4"
                   data-dismiss="modal" (click)="signUp()" style="width: 95%;"
                  [ngClass]="!signupform.valid ? 'invalid-form' : ''">Sign Up</button>
                <div >

                </div>
              </form>
            </div>
            <div class="text-right pr-3 w-65 d-none d-sm-block">
              <img src="" class="img-fluid" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="row text-center pt-100" *ngIf="confirmemailform">
        <div class="col-md-12">
          <div class="row">
            <div class="col pr-sm-0">
              <img src="assets/jointhewailtlist.png" class="img-fluid" alt="">

              <p class="font-weight-500 f-14 mt-4">
                We’ve sent you a confirmation email
              </p>
              <p class=" f-14">
                Click the link in your email to confirm the account.
              </p>
              <p class=" f-14">
                If you can’t find email check your spam folder or click
                link below to resend.
              </p>
            </div>
          </div>
          <button data-testid="auto-app-newsignup-button-4" type="button" class="btn wc-btn-lg f-14 font-weight-bold bgRequestBtn w-60 text-center"
            data-dismiss="modal" routerLink="/login">Back to Login</button>

          <p class="text-blue f-14 ml-1 font-weight-500 mt-4 pointer" (click)="resendVerficationLink()">Resend
            verification email</p>

        </div>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>